import { useCurrentUser } from '@qualio/ui-components';
import { useQuery } from 'react-query';

import { IntegrationAPI } from '../api/integration';

export const useIntegrations = () => {
  const { companyId } = useCurrentUser();

  return useQuery(['integrations', companyId], () => IntegrationAPI.retrieveIntegrations(companyId));
};
